<template>
  <v-container fluid>
    <confirm-dialog v-model="removePromiseGetter"/>
    <v-dialog v-model="dialog" width="400px" persistent>
      <v-card>
        <v-card-text class="pt-8">
          <custom-form
              dense
              v-model="valid"
              :model="model"
              :fields="fields"
              @change="model = $event"
          >
          </custom-form>
          <v-card-actions class="d-flex justify-center">
            <v-btn color="primary" outlined @click="dialog = false">cancel</v-btn>
            <v-btn color="primary" :disabled="!valid" @click="save">save</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="itemsPerPage"
        :page.sync="page"
        :loading="loading"
        :search="search"
        class="elevation-3"
        item-key="id"
        hide-default-footer
        multi-sort
    >
      <template v-slot:top>
        <v-toolbar flat class="pa-0">
          <v-spacer/>
          <v-btn color="primary" @click="editItem">create new version</v-btn>
        </v-toolbar>
        <v-divider/>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="text-right">
          <v-btn color="primary" fab x-small class="mx-2" @click="editItem(item)">
            <v-icon small>edit</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <v-pagination
        class="mt-2"
        v-model="page"
        :length="pageCount"
    ></v-pagination>
  </v-container>
</template>

<script>
export default {
  name: "Formation",
  data: () => ({
    valid: false,
    model: {
    },
    page: 1,
    dialog: false,
    pageCount: 0,
    loading: false,
    itemsPerPage: 500,
    filterByClient: null,
    search: "",
    data: [],
    versionType: [],
    platform: 'web',
    headers: [
      {text: 'id', value: 'id'},
      {text: 'version', value: 'version'},
      {text: 'type', value: 'type.value'},
      {text: 'created', value: 'cdt'},
      {text: '', value: 'actions', sortable: false},
    ],
    removePromiseGetter: null,
  }),
  methods: {
    editItem(item) {
      this.model = {...item}
      this.dialog = true;
    },
    save() {
      this.$http.post(`/${this.platform}/version`, this.model)
          .then(r => this.init(), e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
    },
    init() {
      this.dialog = false;
      this.itemsPerPage = 500
      this.$http.get(`/${this.platform}/version`)
          .then(r => this.data = r.data, e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
    }
  },
  computed: {
    fields() {
      return {
        version: {
          type: String,
          label: 'Name',
          rules: [this.$rule.required],
          disabled: !!this.model?.id
        },
        type: {
          type: Array,
          items: this.versionType,
          label: 'Type',
          text: 'value',
          value: 'value',
          rules: [this.$rule.required],
          returnObject: false
        },
      }
    },
  },
  mounted() {
    this.init();
    this.$http.get(`/${this.platform}/version/version-type`)
        .then(r => this.versionType = r.data, e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
  }
}
</script>

<style scoped>

</style>